import React, { FC, memo } from "react";
import Header from "../../ui_components/header/header";
import styled from "../../theme";

export interface PageHeaderProps {
    /**
     * Page title
     */
    title: string;
    classNameProps?: string;
    customStyle?: any
}

const Container = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0px 0px 0px 10px;
`;

const StyledHeader = styled(Header)`
    margin: 0px 0 10px;
    font-family: "Poppins", serif;
    font-size: 24px;
    letter-spacing: 0px;
    color: #306f82;
    font-weight: 400;

    &.font-24 {
        font-size: 24px !important;
    }
`;

const Content = styled.div`
    align-self: flex-end;
`;

export const PageHeader: FC<PageHeaderProps> = memo((props) => (
    <Container style={props.customStyle}>
        <StyledHeader className={props.classNameProps}>
            {props.title}
        </StyledHeader>
        <Content>{props.children}</Content>
    </Container>
));
